import { createAsyncThunk } from '@reduxjs/toolkit';

import { JsonQuery, type TJsonQuery } from '@/packages/JsonQuery';

import { prepareCities } from '@/microfrontends/filters/shared/mappers/prepareCities';
import { fetchGetCities } from '@/microfrontends/filters/shared/services/fetchCities';
import { type TThunkApi } from '@/microfrontends/filters/shared/store';
import { type ILocation } from '@/microfrontends/filters/shared/types/location';
import { tempNormalizeLocation } from '@/microfrontends/filters/shared/utils/tempNormalizeLocation';

import { updateMeta } from './updateMeta';

const DEFAULT_CITIES: ILocation[] = [];

interface ISelectCitySuggestionResult {
  cities: ILocation[];
  selectedCity: ILocation;
  selectedRegion: ILocation;
  jsonQuery: TJsonQuery;
}

export const selectCitySuggestion = createAsyncThunk<ISelectCitySuggestionResult, ILocation, TThunkApi>(
  'locationPopup/selectCitySuggestion',
  async (city, thunkApi) => {
    const { extra, getState, rejectWithValue, dispatch } = thunkApi;
    const state = getState();
    const subdomain = extra.custom.subdomain;

    if (city.parentId == null || !state.locationPopup.jsonQuery) {
      return rejectWithValue(null);
    }

    const citiesResponse = await fetchGetCities(extra, { regionId: city.parentId }, { subdomain });
    const cities = citiesResponse.map(prepareCities).unwrapOr(DEFAULT_CITIES);
    const selectedRegion = state.regions.filter(r => r.id === city.parentId)[0];

    const nextJsonQuery = new JsonQuery(state.locationPopup.jsonQuery);

    nextJsonQuery.setLocations({ next: [city], prev: tempNormalizeLocation(state.location.data) });

    const nextJsonQuerySerialized = nextJsonQuery.toJSON();

    // специально не блокируемся об получение мета
    dispatch(updateMeta(nextJsonQuerySerialized));

    return {
      cities,
      selectedCity: city,
      selectedRegion,
      jsonQuery: nextJsonQuerySerialized,
    };
  },
);
